<template>
  <div class="goal">
    <h2 class="title">{{score_list.name}}</h2>
    <div class="select_box">
      <div class="sel_list">
        <span>选择球队:</span><select class="select_title comm_sel" @change="changeProduct($event)">
        <option disabled selected hidden>---请选择您支持的球队</option>
        <option v-for="(item,index) in tab_list" :key="item.id"  :value="item.id">{{item.name}}</option>
      </select>
    </div>
      <div class="radio_goal" v-if="sel_box">
        <template v-for="(item1,index) in sel_list">

          <div class="radio_box" v-if="index == 0">
            <input class="comm_radio"  :id="'radio'+index"  type="radio" :value="item1.name" v-model="checked_a">
            <label :for="'radio'+index">{{item1.name}}</label>
          </div>
          <div class="radio_box" v-else>
            <input class="comm_radio"  :id="'radio'+index"  type="radio" :value="item1.name" v-model="checked_a">
            <label :for="'radio'+index">{{item1.name}}</label>
          </div>

        </template>
      </div>
    <template v-if="!score_list.result">
    <div class="sel_list addmargin">
      <span>获取方式：</span>
      <select class="select_title comm_sel" @change="changeGetOption()" v-model="options">
        <option value="现场领取">现场领取</option>
        <option value="邮寄">邮寄</option>
      </select>
    </div>
    <div class="address_box" v-if="is_option">
      <div class="input_box">
        <span>收件人：</span>
        <div class="ins">
          <input class="comm_input" placeholder="收件人" type="text" v-model="input_val1"/>
        </div>
      </div>
      <div class="input_box">
        <span>联系方式：</span>
        <div class="ins">
          <input class="comm_input" placeholder="手机号" type="text" v-model="input_val2"/>
        </div>
      </div>
      <div class="input_box">
        <span>邮寄地址：</span>
        <div class="ins">
          <input class="comm_input" placeholder="邮寄地址" type="text" v-model="input_val3"/>
        </div>
      </div>
    </div>
    <p class="mess_bottom" v-if="!is_option">{{score_list.self_take}}</p>

    <button v-if="btn_isShow" class="sub_btn" :disabled="score_list.guess_count>=score_list.limite_guess_count || score_list.is_over_time==1" @click="subMess">{{score_list.is_over_time==1? '竞猜已结束' : '提交'}}</button>
    </template>
    <template v-if="score_list.result">
      <button class="sub_btn" disabled="true">您的竞猜结果是：{{score_list.result}}</button>
    </template>
  </div>
  </div>
</template>

<script>
    export default {
        name: "GoalGuessing",
        props:{
            score_list:{},
            tab_list:{},

        },
        data() {
            return {
                checked:true,
                is_option: true,
                checked_a:'',
                input_val1:'',
                input_val2:'',
                input_val3:'',
                options:'邮寄',
                btn_isShow:true,
                sel_list:[],
                sel_box:false,
            }
        },
        computed:{
            address(){
                return '收件人：'+this.input_val1+',联系方式'+this.input_val2+',邮寄地址：'+this.input_val3
            }
        },
        mounted(){
        },
        watch:{
            tab_list:function (newVal,oldVal) {
                console.log(newVal)
                this.fir_id = newVal[0].id;
            }
        },

        methods:{
            getSelctList(id) {
                this.$axios({
                    url: 'https://api.hainanfa.org.cn/guess/Get_Guess_Item_Choose_select',
                    method: 'post',
                    params: {
                        choose_id: id
                    },
                    headers:{
                        'Content-Type':'application/json;charset=utf-8'
                    }
                }).then(res => {
                    this.sel_list=res.data.data;
                    this.checked_a = this.sel_list[0].name;
                    console.log(this.sel_list)
                }).catch(err => {
                    console.log(err);
                })
            },
            changeProduct(event){
                this.getSelctList(event.target.value)
                this.sel_box = true
            },

            subMess(){
                console.log(this.checked_a)
                if (this.checked_a == '') {
                    alert('请选择您竞猜的球员');
                    return false
                }
                // return
                if (this.options == '邮寄'){

                    if (this.input_val1 !='' && this.input_val2 !='' && this.input_val3 !='' ) {
                        this.$axios({
                            url:'https://api.hainanfa.org.cn/guess/Submite',
                            method:'post',
                            params:{
                                item_id:this.score_list.id,
                                result:encodeURI(this.checked_a),
                                match_id:this.score_list.match_id,
                                user_id:localStorage.getItem("id"),
                                email_address:encodeURI(this.address)
                            },
                            headers:{
                                'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
                            }
                        }).then(res=>{
                            if (res.data.status == 0){
                                alert('提交成功')
                                this.$router.push({path: 'list'})
                            }
                            if (res.data.status == 400002){
                                alert('您已经竞猜过了，看看别的吧')
                                this.$router.push({path: 'list'})
                            }

                        }).catch(err=>{
                            console.log(err)
                        })
                    }else{
                        alert('请填写好您的信息')
                    }
                }else{
                    this.$axios({
                        url:'https://api.hainanfa.org.cn/guess/Submite',
                        method:'post',
                        params:{
                            item_id:this.score_list.id,
                            result:encodeURI(this.checked_a),
                            match_id:this.score_list.match_id,
                            user_id:localStorage.getItem("id"),
                            email_address:encodeURI('用户现场自取')
                        },
                        headers:{
                            'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
                        }
                    }).then(res=>{
                        if (res.data.status == 0){
                            alert('提交成功')
                            this.$router.push({path: 'list'})
                        }
                        if (res.data.status == 400002){
                            alert('您已经竞猜过了，看看别的吧')
                            this.$router.push({path: 'list'})
                        }

                    }).catch(err=>{
                        console.log(err)
                    })
                }

            },
            changeGetOption() {
                this.is_option = !this.is_option;
                console.log(this.score_list)
            }
        }
    }
</script>

<style scoped>
  .title {
    font-size: 22px;
    font-weight: bold;
    color: #000000;
    line-height: 1.5;
  }

  .select_box {
    margin: 20px 0;
  }
  .radio_goal{
    display: flex;
    flex-wrap: wrap;
  }
  .radio_box{
    flex: 0 0 50%;
    padding-right: 12px;
    margin-bottom: 12px;
  }
.radio_goal{
  margin: 20px 0;
  margin-top: 0;
}
  .sel_list{
    margin-bottom: 20px;
  }
</style>
